import { render } from "./FullSizeGalleryModal.vue?vue&type=template&id=0815809e&ts=true"
import script from "./FullSizeGalleryModal.vue?vue&type=script&lang=ts"
export * from "./FullSizeGalleryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__